var render = function render(_c,_vm){return _c('v-app',{attrs:{"dark":""}},[_c('CircularLoading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }